import { UserProfile } from "types";
import { Location } from "@trnsact/trnsact-shared-types";

export type IntegrationSettingsDialogData = {
  integrationName: string;
  dealerAccountId: string;
  dealerContacts: UserProfile[];
  dealerLocations: Location[];
};

export enum IntegrationSettingsLevel {
  User = "user",
  Location = "location",
  Account = "account",
}

export enum IntegrationSettingsEntryInputType {
  String = "STRING",
  Integer = "INTEGER",
  OptionSet = "OPTION_SET",
}

export enum IntegrationSettingsEntryRequiredStatus {
  Required = "REQUIRED",
  Optional = "OPTIONAL",
}

export type IntegrationSettingsEntry = {
  name: string;
  type: IntegrationSettingsEntryInputType;
  requiredStatus: IntegrationSettingsEntryRequiredStatus;
  level: IntegrationSettingsLevel;
  displayName: string;
  /*   displayInDLM?: boolean; */
};

export interface IntegrationSettingsTypedInputProps {
  integrationSettingsEntry: IntegrationSettingsEntry;
  dataKey: string;
}

export enum IntegrationSettingsTabs {
  User = "user",
  Location = "location",
  Account = "account",
}

/* Table Data */

interface IntegrationSettingsBaseTableData {
  integrationSettingsValuesId: string | null;
  integrationSettingsValues: Record<string, string | any[]> | null;
}

export interface IntegrationSettingsTableDataByLevel {
  [IntegrationSettingsLevel.User]?: IntegrationSettingsUserLevelTableData[];
  [IntegrationSettingsLevel.Location]?: IntegrationSettingsLocationLevelTableData[];
  [IntegrationSettingsLevel.Account]?: IntegrationSettingsAccountLevelTableData[];
}

export interface IntegrationSettingsUserLevelTableData extends IntegrationSettingsBaseTableData {
  userProfileId: string;
  fullName: string;
  title: string;
  email: string;
}

export interface IntegrationSettingsLocationLevelTableData extends IntegrationSettingsBaseTableData {
  locationId: string;
  locationName: string;
  category: string;
}

export interface IntegrationSettingsAccountLevelTableData extends IntegrationSettingsBaseTableData {
  accountId: string;
}

/* Form */

export interface IntegrationSettingsUserLevelForm extends IntegrationSettingsUserLevelTableData {}

export interface IntegrationSettingsLocationLevelForm extends IntegrationSettingsLocationLevelTableData {}

export interface IntegrationSettingsAccountLevelForm extends IntegrationSettingsAccountLevelTableData {}

export interface IntegrationSettingsForm {
  [IntegrationSettingsLevel.User]?: Record<string, IntegrationSettingsUserLevelForm[]>;
  [IntegrationSettingsLevel.Location]?: Record<string, IntegrationSettingsLocationLevelForm[]>;
  [IntegrationSettingsLevel.Account]?: Record<string, IntegrationSettingsAccountLevelForm[]>;
}

export interface IntegrationSettingsOptionToAddForm {
  displayName: string;
  value: string;
}
